import { useEffect, useState } from "react";
import LifeAreaIcon from "./LifeAreaIcon";

/**
 * A Life Area's icon tile.
 *
 * Product's approved icon (plan 49, 2026-10-20; `icon_image_url` from the
 * life-areas list) is a finished tile: its own gradient, white symbol and
 * transparent corners, about 696x647. It renders as is — contain-fit, never
 * stretched, and nothing painted behind or over it (the handoff's rules).
 * Without one, or if it fails to load, the tile is the area colour with the
 * bundled glyph, as before.
 *
 * `className` is the caller's tile box (size, radius); `area` comes from
 * `resolveLifeArea`.
 */
function LifeAreaTile({ area, className = "" }) {
  const url = area?.iconUrl || "";
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [url]);

  if (url && !failed) {
    return (
      <span className={`${className} ex-area-art`}>
        <img src={url} alt="" onError={() => setFailed(true)} />
      </span>
    );
  }
  return (
    <span className={className} style={{ background: area?.color }}>
      <LifeAreaIcon icon={area?.icon} />
    </span>
  );
}

export default LifeAreaTile;
